export default __webpack_public_path__ + "static/media/refresh_icon.69b050ad.svg";